import { cva } from 'class-variance-authority';
/** CVA variants 맵 — lab·문서용 키 추출의 SSOT. */
const buttonVariantMap = {
    default: 'bg-primary text-primary-foreground shadow-xs hover:bg-primary/90',
    destructive: 'bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
    outline: 'border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50',
    secondary: 'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
    ghost: 'hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50',
    link: 'text-primary underline-offset-4 hover:underline',
};
/** 높이·정사각은 --control-height-* (rules-tokens). default는 md 별칭. */
const buttonSizeMap = {
    default: 'h-[length:var(--control-height)] px-4 py-2 has-[>svg]:px-3',
    md: 'h-[length:var(--control-height-md)] px-4 py-2 has-[>svg]:px-3',
    sm: 'h-[length:var(--control-height-sm)] rounded-md space-x-1.5 px-3 has-[>svg]:px-2.5',
    lg: 'h-[length:var(--control-height-lg)] rounded-md px-6 has-[>svg]:px-4',
    icon: 'size-[length:var(--control-height)]',
};
/** lab HOF·문서용 — `cva()` 두 번째 인자와 같은 형태. */
export const buttonCva = {
    variants: {
        variant: buttonVariantMap,
        size: buttonSizeMap,
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
};
export const buttonVariants = cva("inline-flex items-center justify-center space-x-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 aria-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", buttonCva);
/** CVA에 정의된 variant 키 (삽입 순서 유지). */
export const buttonVariantKeys = Object.keys(buttonCva.variants.variant);
/** CVA에 정의된 size 키 (삽입 순서 유지). */
export const buttonSizeKeys = Object.keys(buttonCva.variants.size);
//# sourceMappingURL=button.cva.js.map